import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {normalizeUser, selectCurrentToken, selectCurrentUser, updateUser} from "./authSlice";
import {useGetMeQuery} from "./authApiSlice";

/**
 * Подтягивает актуальный профиль и права из /api/v2/me. Нужен, чтобы после
 * перезагрузки страницы и смены ролей ACL в меню и маршрутах работал по свежим
 * данным, а не по тому, что было в момент логина.
 */
const ProfileSync = () => {
    const dispatch = useDispatch();
    const token = useSelector(selectCurrentToken);
    const user = useSelector(selectCurrentUser);
    const {data} = useGetMeQuery(undefined, {
        skip: !token,
        refetchOnMountOrArgChange: 60
    });

    useEffect(() => {
        const nextUser = normalizeUser(data);
        if (!nextUser) {
            return;
        }
        if (JSON.stringify(nextUser) !== JSON.stringify(user)) {
            dispatch(updateUser(nextUser));
        }
    }, [data, user, dispatch]);

    return null;
};

export default ProfileSync;
